"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var ProductOpportunity_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductOpportunity = void 0;
const typeorm_1 = require("typeorm");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const events_1 = require("../events");
const account_1 = require("./account");
const contact_profile_enum_1 = require("./contact-profile-enum");
const invoicing_target_1 = require("./invoicing-target");
const opportunity_1 = require("./opportunity");
const product_1 = require("./product");
const supplier_types_enum_1 = require("./supplier-types-enum");
let ProductOpportunity = ProductOpportunity_1 = class ProductOpportunity {
};
ProductOpportunity.EVENTS = (0, events_1.makeEventsForClass)(ProductOpportunity_1);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.SearchField(),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", String)
], ProductOpportunity.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.ManyToOne)(() => opportunity_1.Opportunity, (opportunities) => opportunities.productOpportunities, {
        nullable: false,
    }),
    (0, typeorm_1.JoinColumn)({ name: 'opportunity_sfid' }),
    __metadata("design:type", opportunity_1.Opportunity)
], ProductOpportunity.prototype, "opportunity", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        name: 'opportunity_sfid',
        length: 18,
    }),
    __metadata("design:type", String)
], ProductOpportunity.prototype, "opportunitySfid", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.EnumValues(invoicing_target_1.GeneralInvoicingTargetEnum),
    (0, typeorm_1.Column)({
        type: 'enum',
        nullable: false,
        enum: invoicing_target_1.GeneralInvoicingTargetEnum,
        name: 'invoicing_target',
        default: invoicing_target_1.GeneralInvoicingTargetEnum.GID,
    }),
    __metadata("design:type", String)
], ProductOpportunity.prototype, "invoicingTarget", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.ManyToOne)(() => product_1.Product, (product) => product.opportunities, {
        nullable: false,
    }),
    (0, typeorm_1.JoinColumn)(),
    __metadata("design:type", product_1.Product)
], ProductOpportunity.prototype, "product", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)({
        type: 'varchar',
        nullable: false,
        default: '0010Y00001DB9ZWQA1',
    }),
    __metadata("design:type", String)
], ProductOpportunity.prototype, "supplier_sfid", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.ManyToOne)(() => account_1.Account, {
        nullable: false,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'supplier_sfid',
    }),
    __metadata("design:type", account_1.Account)
], ProductOpportunity.prototype, "supplier", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Purchasing Price', emptyToNull: true }),
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], ProductOpportunity.prototype, "pricePurchasing", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Selling Price', emptyToNull: true }),
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], ProductOpportunity.prototype, "priceSelling", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Listing Price', emptyToNull: true }),
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], ProductOpportunity.prototype, "priceListing", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Default Product Supplier' }),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: supplier_types_enum_1.SupplierTypesEnum,
        nullable: false,
    }),
    __metadata("design:type", String)
], ProductOpportunity.prototype, "defaultProductSupplier", void 0);
__decorate([
    (0, typeorm_1.Column)({
        default: false,
    }),
    __metadata("design:type", Boolean)
], ProductOpportunity.prototype, "requireSerialNumber", void 0);
__decorate([
    (0, typeorm_1.Column)({
        default: false,
    }),
    __metadata("design:type", Boolean)
], ProductOpportunity.prototype, "requireChargepointNumber", void 0);
__decorate([
    data_ui_1.DataUi.Description('can be expanded, always visible to Partners for install instructions, supports templating, see https://wiki.getitdone.rocks/doc/job-products-hint-template-2n3UBhmflo'),
    data_ui_1.DataUi.Override({ length: 32768, emptyToNull: true, isRichText: true }),
    (0, typeorm_1.Column)('text', {
        nullable: true,
    }),
    __metadata("design:type", String)
], ProductOpportunity.prototype, "hint", void 0);
ProductOpportunity = ProductOpportunity_1 = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
    }),
    data_ui_1.DataUi.Name({
        name: 'Product Opportunity',
        nameFunction: (i) => { var _a, _b; return `${(_a = i.product) === null || _a === void 0 ? void 0 : _a.name}@${(_b = i.opportunity) === null || _b === void 0 ? void 0 : _b.name}`; },
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('product_opportunities', { schema: 'public' }),
    (0, typeorm_1.Unique)(['product', 'opportunity', 'supplier', 'defaultProductSupplier'])
], ProductOpportunity);
exports.ProductOpportunity = ProductOpportunity;
//# sourceMappingURL=product_opportunity.js.map